var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading && _vm.showLoader)?_c('div',{staticClass:"tc pt2 pb2"},[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-2x fa-fw"})]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"htmlcontent",staticClass:"ajaxcontent"})])
}
var staticRenderFns = []

export { render, staticRenderFns }